import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import toUpperFirst from "ramda-extension/es/toUpperFirst";
import React, { createElement, lazy, Suspense } from 'react';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
const COMPONENT_NAME = 'Icon';
const NotFound = ()=>/*#__PURE__*/ React.createElement("span", null, "error svg icon not found");
// this is shit...
const defaultSvgIconResolver = (name)=>/*#__PURE__*/ lazy(()=>import(`../../SvgIcon/Icons/${toUpperFirst(name)}`).then((module)=>{
            return module;
        }).catch(()=>{
            return {
                default: NotFound
            };
        }));
const Icon = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { name, children, className, svgCompatibility = false, svgIconResolver = defaultSvgIconResolver, containerElement = 'i', ...other } = props;
    if (svgCompatibility) {
        const SvgIcon = svgIconResolver(name);
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: /*#__PURE__*/ React.createElement("span", null)
        }, /*#__PURE__*/ React.createElement(SvgIcon, {
            className: className,
            ...other
        }));
    }
    return /*#__PURE__*/ createElement(containerElement, {
        className: cx(`Icon Icon--${name}`, className),
        ...other
    }, children);
};
Icon.propTypes = {
    /**
	 * Any children node can be included inside the `i` element.
	 */ children: PropTypes.node,
    /**
	 * Additional className selector that can be applied.
	 */ className: PropTypes.string,
    /**
	 * Container element of icon
	 */ containerElement: PropTypes.string,
    /**
	 * Icon name
	 */ name: PropTypes.string.isRequired,
    /**
	 * Turns this icon into SvgIcon with same name. It is only for temporary transition between font and svg icons.
	 * Do not use it directly. It will be removed in future together with font icons.
	 */ svgCompatibility: PropTypes.bool,
    /**
	 * Used during temporary svg icon transition to correctly resolve SvgIcons in you application.
	 * @example
	 *
	 * const svgIconsResolver = (iconName) => React.lazy(() => .....);
	 */ svgIconResolver: PropTypes.func
};
export default Icon;
